import {z} from '@hono/zod-openapi';

// Not `.strict()`. This is a beta vendor payload nested inside IncomingVoiceCallWebhookSchema, which
// deliberately stays non-strict for the same reason: OpenAI can add a field to a sip_headers[] entry
// at any time, and rejecting an unrecognized key would turn that into a 400 that blocks every
// inbound call until the schema is updated.
export const SipHeaderSchema = z
  .object({
    name: z.string().min(1),
    value: z.string(),
  })
  .openapi('SipHeaderSchema');

export type SipHeader = z.infer<typeof SipHeaderSchema>;
